import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAffiliation, useAuth } from '../index'

const { env } = window

const useCategories = () => {
  const { loggedIn, securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { affiliation } = useAffiliation()

  const getCategories = async (affiliationId) => {
    const fetchFn = loggedIn ? securedFetch : fetch
    const url = encodeURI(
      loggedIn
        ? `${env.apiUrl}/affiliations/${affiliationId}/userCategories`
        : `${env.publicApiUrl}/affiliations/${affiliationId}/categories`
    )
    const response = await fetchFn(url)
    await handleResponse(response)
    return response.json()
  }

  const query = useQuery({
    queryKey: ['categories', affiliation?.id],
    queryFn: () => getCategories(affiliation?.id),
    enabled: !!affiliation
  })

  useEffect(() => {
    if (query.isError) {
      handleError(query.error, 'Error getting categories')
    }
  }, [query.isError, query.error, handleError])

  return {
    categories: query.data
  }
}

export { useCategories }
